import React from 'react';
import { ClockIcon } from 'lucide-react';
import { useCountdown } from '../hooks/useCountdown';
interface CountdownProps {
  label?: string;
  tone?: 'light' | 'dark';
}
export function Countdown({
  label = 'Special offer ends in:',
  tone = 'light'
}: CountdownProps) {
  const {
    hours,
    minutes,
    seconds
  } = useCountdown();
  const isDark = tone === 'dark';
  const units = [{
    value: hours,
    caption: 'Hours'
  }, {
    value: minutes,
    caption: 'Min'
  }, {
    value: seconds,
    caption: 'Sec'
  }];
  return <div className="mx-auto w-full max-w-md text-center" data-id="element-25" data-mp="3h18vms7me26z">
      <p className={`flex items-center justify-center gap-1.5 text-[11px] font-bold uppercase tracking-[0.14em] ${isDark ? 'text-aqua-200' : 'text-navy-800/70'}`} data-id="element-26" data-mp="3gymh28mbamf9">
        <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-27" data-mp="374mas3fanb4y" />
        {label}
      </p>
      <div className="mt-3 flex items-stretch justify-center gap-2" data-id="element-28" data-mp="10a8wwfjcac1m">
        {units.map((unit, i) => <React.Fragment key={unit.caption} data-id="element-29" data-mp="15927o078roy3" data-mpi={i}>
            <div className={`flex min-w-[68px] flex-1 flex-col items-center rounded-xl px-2 py-2.5 sm:min-w-[80px] ${isDark ? 'bg-white/10 ring-1 ring-white/20' : 'bg-navy-800 shadow-card'}`} data-id="element-30" data-mp="y04xs77s3ssm">
              <span className="font-display text-3xl font-bold tabular-nums text-white sm:text-4xl" data-id="element-31" data-mp="17sssmwf77mop">
                {unit.value}
              </span>
              <span className="mt-0.5 text-[10px] font-semibold uppercase tracking-widest text-aqua-200" data-id="element-32" data-mp="f3dkqfity9x0">
                {unit.caption}
              </span>
            </div>
            {i < units.length - 1 ? <span className={`self-center font-display text-2xl font-bold ${isDark ? 'text-white/40' : 'text-navy-800/30'}`} aria-hidden="true" data-id="element-33" data-mp="o4k02l9qteoo">
                :
              </span> : null}
          </React.Fragment>)}
      </div>
      <p className={`mt-2.5 text-[11.5px] ${isDark ? 'text-white/60' : 'text-navy-800/55'}`} data-id="element-34" data-mp="s5n5cy4afma2">
        The promotional price may change.
      </p>
    </div>;
}